/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../../core";
export const ExchangeTokenRequest = core.serialization.object({
    token: core.serialization.string().optional(),
    email: core.serialization.string().optional(),
    spaceId: core.serialization.string().optional(),
});
